import 'css-chunksrc/client/scenes/preferences/languageSelectionForm/styles.scss';export default {
  "languageSelectionForm": "_languageSelectionForm_1jfip_1",
  "group": "_group_1jfip_10",
  "input": "_input_1jfip_21",
  "selectedInput": "_selectedInput_1jfip_29",
  "language": "_language_1jfip_1"
};